import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const FeaturedArticle = ({ article }) => {
  return (
    <div className="relative bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300">
      <div className="relative h-64 sm:h-80 overflow-hidden">
        <Image
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-4 left-4">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-orange-500 text-white">
            Featured
          </span>
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-center space-x-4 mb-4">
          <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-800">
            {article.category}
          </span>
          <span className="text-sm text-gray-600">
            {article.readTime} min read
          </span>
        </div>

        <h2 className="text-xl font-bold font-heading text-gray-900 mb-3 line-clamp-2">
          {article.title}
        </h2>

        <p className="text-gray-700 mb-4 line-clamp-3">
          {article.excerpt}
        </p>

        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Image
              src={article.author.avatar}
              alt={article.author.name}
              className="w-8 h-8 rounded-full object-cover"
            />
            <div>
              <p className="text-sm font-medium text-gray-900">
                {article.author.name}
              </p>
              <p className="text-xs text-gray-600">
                {article.publishDate}
              </p>
            </div>
          </div>

          <Link
            to={`/insights-blog/${article.slug}`}
            className="inline-flex items-center space-x-2 text-blue-600 hover:text-blue-800 transition-colors duration-200"
          >
            <span className="text-sm font-medium">Read More</span>
            <Icon name="ArrowRight" size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturedArticle;